
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("f9s7v", function(module, exports) {
$parcel$export(module.exports, "JswExpandableProjectQuery", () => $dfd3bd3af9172b73$export$5345c2cb0d82dbb1);

var $gxGDD = parcelRequire("gxGDD");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $9yCN1 = parcelRequire("9yCN1");
function $dfd3bd3af9172b73$export$5345c2cb0d82dbb1({ queries: { projects: projects } }) {
    const data = (0, $j4oe4.usePreloadedQuery)((0, $gxGDD.default), projects);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9yCN1.JswBoards), {
        queryRef: data.jira.jiraProjectByKey
    });
}

});
parcelRegister("9yCN1", function(module, exports) {
$parcel$export(module.exports, "JswBoards", () => $502b0b0376b6698c$export$f0eb9767edce62ae);

var $1898G = parcelRequire("1898G");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7XH79 = parcelRequire("7XH79");

var $Wdhjx = parcelRequire("Wdhjx");

var $8Umc4 = parcelRequire("8Umc4");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $lHnXI = parcelRequire("lHnXI");

var $h4Bzb = parcelRequire("h4Bzb");

var $dpxw4 = parcelRequire("dpxw4");

var $cbCSE = parcelRequire("cbCSE");

var $bo95Y = parcelRequire("bo95Y");

var $azEgq = parcelRequire("azEgq");

var $1Ce3C = parcelRequire("1Ce3C");

var $26YI7 = parcelRequire("26YI7");

var $2VSqh = parcelRequire("2VSqh");

var $3Z5Oj = parcelRequire("3Z5Oj");

var $cxKOj = parcelRequire("cxKOj");

var $2FqDG = parcelRequire("2FqDG");
var $83DiZ = parcelRequire("83DiZ");

var $eNJMe = parcelRequire("eNJMe");


var $6y2u3 = parcelRequire("6y2u3");
function $502b0b0376b6698c$var$buildBoardHref(projectKey, url) {
    return {
        to: url ?? `/browse/${projectKey}`,
        prefetch: 'hover'
    };
}
const $502b0b0376b6698c$var$transformNodeToBoard = (node)=>{
    const { __id: __id, boardId: boardId, boardType: boardType, favouriteValue: favouriteValue, name: name, canEdit: canEdit } = node || {};
    const isPublicBoard = !!name;
    if (__id && boardType && boardId) return isPublicBoard ? {
        id: boardId.toString(),
        dataId: __id,
        admins: {
            users: [],
            groups: []
        },
        canEdit: !!canEdit,
        name: name,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        type: boardType,
        favourite: !!favouriteValue?.isFavourite
    } : {
        id: boardId.toString(),
        dataId: __id,
        admins: {
            users: [],
            groups: []
        },
        canEdit: !!canEdit,
        isPrivate: true
    };
};
function $502b0b0376b6698c$export$f0eb9767edce62ae({ queryRef: queryRef }) {
    const { sendBoardNavigationItemInsideProjectsAnalyticsEvent: sendBoardNavigationItemInsideProjectsAnalyticsEvent, sendViewAllBoardsAnalyticsEvent: sendViewAllBoardsAnalyticsEvent } = (0, $lHnXI.useProjectsAnalyticsL2)();
    const [project, refetch] = (0, $j4oe4.useRefetchableFragment)((0, $1898G.default), queryRef);
    const [boardsSuspenselessRefetch] = (0, $7XH79.useSuspenselessRefetch)((0, $2VSqh.default), refetch, {
        fetchPolicy: 'network-only'
    });
    const onSubscribeToFavorite = (0, $eJOHy.useCallback)(()=>{
        boardsSuspenselessRefetch({
            id: project.id,
            noOfBoardsToFetch: (0, $62baa2e6fd157602$export$420a3ee5deb615a9)
        });
    }, [
        boardsSuspenselessRefetch,
        project.id
    ]);
    (0, $8Umc4.useSubscribeToFavorite)('JiraBoard', onSubscribeToFavorite);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { isSelectedPath: isSelectedPath } = (0, $dpxw4.useSidebarNav4)();
    const { isControlledPath: isControlledPath } = (0, $cbCSE.useSidebarNav4Controller)();
    const viewAllBoardsInProjectHref = `${(0, $3Z5Oj.boardsDirectoryRoute).path}?projectLocation=${project.projectKey}`;
    const noOfFavouriteBoards = project.boards?.edges?.filter((edge)=>edge?.node?.favouriteValue?.isFavourite).length ?? 0;
    const noOfBoardsToShow = Math.min(noOfFavouriteBoards + (0, $62baa2e6fd157602$export$99240e55cc48c47e), (0, $62baa2e6fd157602$export$420a3ee5deb615a9));
    const boardsToShow = (0, $4cTDP.fg)('blu-4626-sorted-project-boards-fe') ? project?.boards?.edges?.slice(0, noOfBoardsToShow) ?? [] : project?.boards?.edges;
    const showViewAllBoards = (0, $4cTDP.fg)('blu-4626-sorted-project-boards-fe') ? project.softwareBoardCount > noOfBoardsToShow : project.softwareBoardCount > (0, $62baa2e6fd157602$export$420a3ee5deb615a9);
    const mostRecentlyViewedBoardId = project.mostRecentlyViewedBoard?.boardId;
    const projId = (0, $h4Bzb.ENTITY_ID).PROJECT(project.projectKey);
    const isProjectSelected = isSelectedPath(projId);
    const isAnyBoardSelected = boardsToShow?.some((board)=>board && board.node && board.node.boardId && isSelectedPath((0, $h4Bzb.ENTITY_ID).BOARD(board.node.boardId.toString()))) ?? false;
    const isProjectScoped = isProjectSelected && !isAnyBoardSelected;
    const projectKey = project.projectKey;
    const boardIdPath = (0, $2FqDG.usePathParam)('boardId')[0];
    // the result from the JswBoards query can sometimes be out of sync - eg when creating a new board
    // .: if the project is selected, and we are on board-scoped routes (ie boardIdPath is not undefined)
    // we check if the mostRecentlyViewedBoard matches the current selected path
    // if mostRecentlyViewedBoard does not match, we refetch boards
    (0, $eJOHy.useEffect)(()=>{
        const isMostRecentlyViewedBoardOutofSync = isProjectSelected && boardIdPath && mostRecentlyViewedBoardId && !isSelectedPath((0, $h4Bzb.ENTITY_ID).BOARD(mostRecentlyViewedBoardId.toString()));
        if ((0, $cxKOj.expVal)('blu-6805-fix-board-sync', 'isEnabled', false)) {
            if (isMostRecentlyViewedBoardOutofSync) boardsSuspenselessRefetch({
                id: project.id,
                noOfBoardsToFetch: (0, $62baa2e6fd157602$export$420a3ee5deb615a9)
            });
            else if (isProjectSelected && boardIdPath && mostRecentlyViewedBoardId) {
                // Even if most recently viewed board is in sync, we need to check if boards are in the correct order. If not, we need to refetch.
                const isMostRecentlyViewedBoardFavourite = project.boards?.edges?.find((edge)=>edge?.node?.boardId === mostRecentlyViewedBoardId)?.node?.favouriteValue?.isFavourite;
                const expectedBoardIndex = isMostRecentlyViewedBoardFavourite ? 0 : noOfFavouriteBoards;
                const isBoardInCorrectPosition = mostRecentlyViewedBoardId === project.boards?.edges?.[expectedBoardIndex]?.node?.boardId;
                if (!isBoardInCorrectPosition) boardsSuspenselessRefetch({
                    id: project.id,
                    noOfBoardsToFetch: (0, $62baa2e6fd157602$export$420a3ee5deb615a9)
                });
            }
        }
    }, [
        boardsSuspenselessRefetch,
        project.id,
        isProjectSelected,
        boardIdPath,
        mostRecentlyViewedBoardId,
        isSelectedPath,
        noOfFavouriteBoards,
        project.boards?.edges
    ]);
    const handleBoardClick = (0, $eJOHy.useCallback)((boardId)=>()=>{
            sendBoardNavigationItemInsideProjectsAnalyticsEvent({
                recent: !project.isFavourite,
                starred: project.isFavourite ?? false,
                projectId: project.projectId,
                boardId: boardId,
                projectType: project.projectType
            });
        }, [
        project.isFavourite,
        project.projectId,
        project.projectType,
        sendBoardNavigationItemInsideProjectsAnalyticsEvent
    ]);
    const handleAllBoardsClick = (0, $eJOHy.useCallback)(()=>()=>{
            sendViewAllBoardsAnalyticsEvent({
                projectId: project.projectId,
                projectType: project.projectType
            });
        }, [
        project.projectId,
        project.projectType,
        sendViewAllBoardsAnalyticsEvent
    ]);
    const { push: push } = (0, $4cTDP.fg)('navx-1724-add-auto-select-behaviour') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $83DiZ.useRouterActions)() : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {
        push: $502b0b0376b6698c$var$noop
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, boardsToShow?.map((edge, index)=>{
        if (!edge?.node?.boardId) return [];
        const href = $502b0b0376b6698c$var$buildBoardHref(projectKey, edge.node.defaultNavigationItem?.url);
        return (0, $4cTDP.fg)('navx-1724-add-auto-select-behaviour') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eNJMe.RedirectOnLoad), {
            key: edge.node.id,
            condition: index === 0 && !isAnyBoardSelected,
            href: href.to,
            redirect: push
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bo95Y.default), {
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($Wdhjx))), {
                label: "",
                color: "currentColor"
            }),
            href: href,
            testId: (0, $azEgq.getTestId)((0, $h4Bzb.ENTITY_ID).BOARD(edge.node.boardId.toString())),
            actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $26YI7.BoardActions), {
                board: $502b0b0376b6698c$var$transformNodeToBoard(edge.node),
                projectFragment: project,
                placement: "right",
                isParentProjectStarred: project.isFavourite,
                isBoardFavorite: edge.node.favouriteValue?.isFavourite ?? undefined,
                iconButtonSpacing: "compact"
            }),
            onClick: handleBoardClick(edge.node.boardId),
            isSelected: isSelectedPath((0, $h4Bzb.ENTITY_ID).BOARD(edge.node.boardId.toString())) || isControlledPath((0, $h4Bzb.ENTITY_ID).BOARD(edge.node.boardId.toString())) || isProjectScoped && edge.node.boardId === mostRecentlyViewedBoardId
        }, edge.node.name)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bo95Y.default), {
            key: edge.node.id,
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($Wdhjx))), {
                label: "",
                color: "currentColor"
            }),
            href: href,
            testId: (0, $azEgq.getTestId)((0, $h4Bzb.ENTITY_ID).BOARD(edge.node.boardId.toString())),
            actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $26YI7.BoardActions), {
                board: $502b0b0376b6698c$var$transformNodeToBoard(edge.node),
                projectFragment: project,
                placement: "right",
                isParentProjectStarred: project.isFavourite,
                isBoardFavorite: edge.node.favouriteValue?.isFavourite ?? undefined,
                iconButtonSpacing: "compact"
            }),
            onClick: handleBoardClick(edge.node.boardId),
            isSelected: isSelectedPath((0, $h4Bzb.ENTITY_ID).BOARD(edge.node.boardId.toString())) || isControlledPath((0, $h4Bzb.ENTITY_ID).BOARD(edge.node.boardId.toString())) || isProjectScoped && edge.node.boardId === mostRecentlyViewedBoardId
        }, edge.node.name);
    }), showViewAllBoards && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Ce3C.ViewAllEntityMenuItem), {
        onClick: handleAllBoardsClick,
        href: viewAllBoardsInProjectHref,
        menuId: (0, $h4Bzb.MENU_ID_BOARDS_VIEW_ALL)
    }, formatMessage((0, $6y2u3.default).viewAllBoardsNonFinal)));
}
// Remove when navx-1724-add-auto-select-behaviour is cleaned up
const $502b0b0376b6698c$var$noop = ()=>{
/* empty */ };

});
parcelRegister("1898G", function(module, exports) {
$parcel$export(module.exports, "default", () => $399029c7bfa4784f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2d14e70343a1b400d36561fc0bc5a164>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $2VSqh = parcelRequire("2VSqh");
const $399029c7bfa4784f$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v2 = {
        "kind": "ScalarField",
        "name": "boardId"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "noOfBoardsToFetch"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "refetch": {
                "fragmentPathInResult": [
                    "node"
                ],
                "operation": (0, $2VSqh.default),
                "identifierInfo": {
                    "identifierField": "id",
                    "identifierQueryVariableName": "id"
                }
            }
        },
        "name": "JswBoards",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "BoardActions"
            },
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "projectId"
                },
                "action": "THROW",
                "path": "projectId"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "projectKey",
                    "kind": "ScalarField",
                    "name": "key"
                },
                "action": "THROW",
                "path": "projectKey"
            },
            {
                "kind": "ScalarField",
                "name": "projectType"
            },
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "first",
                        "variableName": "noOfBoardsToFetch"
                    }
                ],
                "concreteType": "JiraBoardConnection",
                "kind": "LinkedField",
                "name": "boards",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraBoardEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraBoard",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "name"
                                    },
                                    v2 /*: any*/ ,
                                    {
                                        "kind": "LinkedField",
                                        "name": "defaultNavigationItem",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "url"
                                                    }
                                                ],
                                                "type": "JiraNavigationItem",
                                                "abstractKey": "__isJiraNavigationItem"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraFavouriteValue",
                                        "kind": "LinkedField",
                                        "name": "favouriteValue",
                                        "plural": false,
                                        "selections": [
                                            v1 /*: any*/ 
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "boardType"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "canEdit"
                                    },
                                    {
                                        "kind": "ClientExtension",
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "ScalarField",
                                                    "name": "__id"
                                                },
                                                "action": "THROW",
                                                "path": "boards.edges.node.__id"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "name": "mostRecentlyViewedBoard",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v2 /*: any*/ 
                        ],
                        "type": "JiraBoard"
                    }
                ]
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "softwareBoardCount"
                },
                "action": "THROW",
                "path": "softwareBoardCount"
            }
        ],
        "type": "JiraProject"
    };
}();
$399029c7bfa4784f$var$node.hash = "3c773ea42ae4857f7fb5a6cc007cd433";
var $399029c7bfa4784f$export$2e2bcd8739ae039 = $399029c7bfa4784f$var$node;

});
parcelRegister("2VSqh", function(module, exports) {
$parcel$export(module.exports, "default", () => $62afb5431bcb37b9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<576190015551292816291fcefbfa49ec>>
 * @relayHash 81b7014fbbf41d99d7da20bc4965a8c7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9c3e57f762154dff560aea6af79ebdc06920810837a0b25a1f5ce0d9efc92f2f
const $62afb5431bcb37b9$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "noOfBoardsToFetch"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v6 = {
        "kind": "ScalarField",
        "name": "boardId"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            v4 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "JswBoardsRefetchQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "noOfBoardsToFetch",
                                    "variableName": "noOfBoardsToFetch"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "JswBoards"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "JswBoardsRefetchQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "alias": "projectKey",
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectType"
                                },
                                v5 /*: any*/ ,
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "first",
                                            "variableName": "noOfBoardsToFetch"
                                        }
                                    ],
                                    "concreteType": "JiraBoardConnection",
                                    "kind": "LinkedField",
                                    "name": "boards",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraBoardEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraBoard",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        v6 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "defaultNavigationItem",
                                                            "plural": false,
                                                            "selections": [
                                                                v3 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        }
                                                                    ],
                                                                    "type": "JiraNavigationItem",
                                                                    "abstractKey": "__isJiraNavigationItem"
                                                                },
                                                                v7 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraFavouriteValue",
                                                            "kind": "LinkedField",
                                                            "name": "favouriteValue",
                                                            "plural": false,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                v4 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "boardType"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "canEdit"
                                                        },
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__id"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "mostRecentlyViewedBoard",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v6 /*: any*/ 
                                            ],
                                            "type": "JiraBoard"
                                        },
                                        v7 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "softwareBoardCount"
                                }
                            ],
                            "type": "JiraProject"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9c3e57f762154dff560aea6af79ebdc06920810837a0b25a1f5ce0d9efc92f2f",
            "metadata": {},
            "name": "JswBoardsRefetchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$62afb5431bcb37b9$var$node.hash = "3c773ea42ae4857f7fb5a6cc007cd433";
var $62afb5431bcb37b9$export$2e2bcd8739ae039 = $62afb5431bcb37b9$var$node;

});


parcelRegister("7XH79", function(module, exports) {
$parcel$export(module.exports, "useSuspenselessRefetchStateless", () => $a5387c0f4da0e3f5$export$ae1adabf094b2244);
$parcel$export(module.exports, "useSuspenselessRefetch", () => $a5387c0f4da0e3f5$export$c7ce5f64dc007896);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4im1M = parcelRequire("4im1M");
const $a5387c0f4da0e3f5$var$useInFlightRequests = ({ setIsLoading: setIsLoading })=>{
    const inFlightRequestsRef = (0, $eJOHy.useRef)([]);
    return (0, $eJOHy.useMemo)(()=>({
            onNewRequest: (request)=>{
                inFlightRequestsRef.current.push(request);
            },
            onRequestFinish: (request, /**
				 * Called only if the request hasn't been superceded by a more recent request's success / failure
				 */ onIfRequestIsRelevant)=>{
                // find the first occurrence of this request
                const inFlightRequestIndex = inFlightRequestsRef.current.indexOf(request);
                // If the current request is still considered "in flight"
                if (inFlightRequestIndex !== -1) {
                    onIfRequestIsRelevant?.();
                    // Cut out the current and all proceeding requests from the in-flight queue
                    inFlightRequestsRef.current = inFlightRequestsRef.current.slice(inFlightRequestIndex + 1);
                    // Update isLoading to reflect the current number of in-flight requests
                    setIsLoading?.(!!inFlightRequestsRef.current.length);
                }
            }
        }), [
        setIsLoading
    ]);
};
const $a5387c0f4da0e3f5$export$ae1adabf094b2244 = (// Relay-generated query from the @refetchable annotation in a useRefetchableFragment
// or usePaginationFragment
query, // Refetch function from a useRefetchableFragment or usePaginationFragment
// (which ordinarily would trigger suspense)
refetch, { setIsLoading: setIsLoading, setLastFetchError: setLastFetchError, fetchPolicy: fetchPolicy = 'store-or-network', networkCacheConfig: networkCacheConfig } = {})=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const isMounted = (0, $4im1M.useIsMounted)();
    const { onNewRequest: onNewRequest, onRequestFinish: onRequestFinish } = $a5387c0f4da0e3f5$var$useInFlightRequests({
        setIsLoading: setIsLoading
    });
    const [_, startTransition] = (0, $eJOHy.useTransition)();
    return (0, $eJOHy.useCallback)((variables, options)=>{
        if (isMounted.current) setIsLoading?.(true);
        onNewRequest(variables);
        return (0, $j4oe4.fetchQuery)(environment, query, variables, {
            fetchPolicy: fetchPolicy,
            networkCacheConfig: networkCacheConfig
        }).subscribe({
            complete () {
                if (isMounted.current) {
                    if (startTransition) // we need concurrent mode for useTransition to work
                    startTransition(()=>{
                        setLastFetchError?.(null);
                        onRequestFinish(variables, ()=>{
                            refetch(variables, {
                                fetchPolicy: 'store-only'
                            });
                            options?.onComplete?.();
                        });
                    });
                    else {
                        setLastFetchError?.(null);
                        onRequestFinish(variables, ()=>{
                            refetch(variables, {
                                fetchPolicy: 'store-only'
                            });
                            options?.onComplete?.();
                        });
                    }
                }
            },
            error (e) {
                if (isMounted.current) onRequestFinish(variables, ()=>setLastFetchError?.(e));
            }
        });
    }, [
        environment,
        fetchPolicy,
        isMounted,
        networkCacheConfig,
        onNewRequest,
        onRequestFinish,
        query,
        refetch,
        setIsLoading,
        setLastFetchError,
        startTransition
    ]);
};
const $a5387c0f4da0e3f5$export$c7ce5f64dc007896 = (query, refetch, options)=>{
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const [lastFetchError, setLastFetchError] = (0, $eJOHy.useState)(null);
    const refetchFunction = $a5387c0f4da0e3f5$export$ae1adabf094b2244(query, refetch, {
        ...options,
        setIsLoading: setIsLoading,
        setLastFetchError: setLastFetchError
    });
    return [
        refetchFunction,
        isLoading,
        lastFetchError
    ];
};

});
parcelRegister("4im1M", function(module, exports) {
$parcel$export(module.exports, "useIsMounted", () => $bb7ff1168b248128$export$80c2a3957bcb42ea);

var $eJOHy = parcelRequire("eJOHy");
const $bb7ff1168b248128$export$80c2a3957bcb42ea = ()=>{
    const isMounted = (0, $eJOHy.useRef)(true);
    (0, $eJOHy.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, [
        isMounted
    ]);
    return isMounted;
};

});


parcelRegister("26YI7", function(module, exports) {
$parcel$export(module.exports, "BoardActions", () => $195de85280efbd0f$export$bb50bc4d1176eb2f);

var $7DE59 = parcelRequire("7DE59");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $NByNW = parcelRequire("NByNW");

var $Ay1uj = parcelRequire("Ay1uj");

var $4MicW = parcelRequire("4MicW");

var $4F5bb = parcelRequire("4F5bb");

var $7saMl = parcelRequire("7saMl");
var $f58rc = parcelRequire("f58rc");
var $jUgeq = parcelRequire("jUgeq");
var $6YEko = parcelRequire("6YEko");

var $3cMgR = parcelRequire("3cMgR");

var $bu8Y7 = parcelRequire("bu8Y7");

var $9Wqfs = parcelRequire("9Wqfs");

var $lRq8t = parcelRequire("lRq8t");

var $8QGVd = parcelRequire("8QGVd");


var $1OC2y = parcelRequire("1OC2y");

var $8Btof = parcelRequire("8Btof");

var $6Hwhu = parcelRequire("6Hwhu");

var $8nMzv = parcelRequire("8nMzv");

var $cHtIB = parcelRequire("cHtIB");

var $83DiZ = parcelRequire("83DiZ");

var $aMOdH = parcelRequire("aMOdH");

var $1T6m6 = parcelRequire("1T6m6");

var $QaFzq = parcelRequire("QaFzq");

var $1302Y = parcelRequire("1302Y");

var $9cReq = parcelRequire("9cReq");
const $195de85280efbd0f$export$bb50bc4d1176eb2f = /*#__PURE__*/ (0, $eJOHy.memo)(({ board: board, projectFragment: projectFragment, placement: placement, isBoardFavorite: isBoardFavorite = false, isParentProjectStarred: isParentProjectStarred, forceOpen: forceOpen = false, iconButtonSpacing: iconButtonSpacing = 'default', themed: themed = false })=>{
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(forceOpen);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { sendMeatBallDropDownOnBoardsAnalyticsEvent: sendMeatBallDropDownOnBoardsAnalyticsEvent } = (0, $1OC2y.useProjectsAnalyticsL3)();
    const { sendMeatBallDropDownOnBoardsMenuItemAnalyticsEvent: sendMeatBallDropDownOnBoardsMenuItemAnalyticsEvent } = (0, $8Btof.useProjectsAnalyticsL4)();
    const project = (0, $j4oe4.useFragment)((0, $7DE59.default), projectFragment);
    const tenantId = (0, $cHtIB.useCloudId)();
    const boardARI = (0, $bu8Y7.JiraSoftwareBoardAri).create({
        siteId: tenantId,
        boardId: board?.id.toString() ?? ''
    }).toString();
    const [showDeleteModal, setShowDeleteModal] = (0, $eJOHy.useState)(false);
    const boardId = board?.id || '';
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const route = (0, $QaFzq.useRoute)();
    const isBacklogUrl = (0, $8QGVd.isBacklogRoute)(route.name);
    const openModal = ()=>{
        setShowDeleteModal(true);
        sendMeatBallDropDownOnBoardsMenuItemAnalyticsEvent({
            recent: !isParentProjectStarred,
            starred: isParentProjectStarred ?? false,
            boardId: Number(boardId),
            itemId: (0, $bc40578f06d7846b$export$a68d619e7022f2c3),
            projectId: project?.projectId ?? '',
            projectType: project?.projectType
        });
    };
    const handleBoardDelete = ()=>{
        if (!board?.dataId) return;
        setShowDeleteModal(false);
        push(`/browse/${project?.projectKey}`);
    };
    const handleModalCancel = ()=>{
        setShowDeleteModal(false);
    };
    const IconButton = themed && (0, $1302Y.getIsSoftwareThemingM2Enabled)() ? (0, $aMOdH.ThemedIconButton) : (0, $Ay1uj.default);
    const onBoardDeleteFailed = (0, $eJOHy.useCallback)(()=>setShowDeleteModal(false), []);
    const onTriggerClick = (0, $eJOHy.useCallback)(()=>{
        setIsOpen(!isOpen);
        sendMeatBallDropDownOnBoardsAnalyticsEvent({
            recent: !isParentProjectStarred,
            starred: isParentProjectStarred ?? false,
            boardId: Number(boardId),
            projectId: project?.projectId ?? '',
            projectType: project?.projectType
        });
    }, [
        isOpen,
        sendMeatBallDropDownOnBoardsAnalyticsEvent,
        isParentProjectStarred,
        boardId,
        project?.projectId,
        project?.projectType
    ]);
    const onClose = (0, $eJOHy.useCallback)(()=>setIsOpen(false), []);
    if (!project?.projectKey) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nMzv.JiraPopup), {
        isOpen: isOpen,
        onClose: onClose,
        placement: placement ?? 'bottom-start',
        testId: "navigation-board-action-menu.ui.popup",
        messageId: "navigation-board-action-menu.ui.popup",
        messageType: "transactional",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jUgeq.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6YEko.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6Hwhu.FavoriteToggleButton), {
                entityId: boardARI,
                entityTypeName: "JiraBoard",
                defaultIsStarred: isBoardFavorite,
                onClick: ()=>sendMeatBallDropDownOnBoardsMenuItemAnalyticsEvent({
                        recent: !isParentProjectStarred,
                        starred: isParentProjectStarred ?? false,
                        itemId: isBoardFavorite ? (0, $bc40578f06d7846b$export$7ae7abcf2c19d3e5) : (0, $bc40578f06d7846b$export$78fd0bd637fe1684),
                        boardId: Number(boardId),
                        projectId: project?.projectId ?? '',
                        projectType: project?.projectType
                    })
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f58rc.default), {
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4F5bb))), {
                    label: "",
                    color: "var(--ds-icon, #44546F)",
                    spacing: "spacious"
                }),
                "aria-label": formatMessage((0, $9cReq.default).boardSettingsLabel),
                href: $195de85280efbd0f$var$getJSWCMPBoardSettingsUrl(project?.projectKey, boardId, isBacklogUrl),
                onClick: ()=>{
                    sendMeatBallDropDownOnBoardsMenuItemAnalyticsEvent({
                        recent: !isParentProjectStarred,
                        starred: isParentProjectStarred ?? false,
                        boardId: Number(boardId),
                        itemId: (0, $bc40578f06d7846b$export$192d610b0b7719f4),
                        projectId: project?.projectId ?? '',
                        projectType: project?.projectType
                    });
                }
            }, formatMessage((0, $9cReq.default).boardSettingsLabel))), board?.canEdit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6YEko.default), {
                hasSeparator: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7saMl.default), {
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4MicW))), {
                    label: "",
                    spacing: "spacious",
                    color: "var(--ds-icon-accent-red, #C9372C)"
                }),
                onClick: openModal
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                color: "color.text.danger"
            }, formatMessage((0, $9cReq.default).deleteBoardLabel))))), board?.canEdit && showDeleteModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Wqfs.default), {
                board: board,
                onBoardDeleteFailed: onBoardDeleteFailed,
                onBoardDeleted: handleBoardDelete,
                onCancel: handleModalCancel
            })),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(IconButton, {
                ...triggerProps,
                icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NByNW))), {
                        ...iconProps,
                        size: "small"
                    }),
                label: formatMessage((0, $9cReq.default).dropdownIconLabel),
                appearance: "subtle",
                spacing: iconButtonSpacing,
                onClick: onTriggerClick,
                isSelected: isOpen,
                testId: "navigation-board-action-menu.ui.dropdown"
            }),
        shouldRenderToParent: true
    });
});
function $195de85280efbd0f$var$getJSWCMPBoardSettingsUrl(projectKey, boardId, isBacklogUrl) {
    const query = isBacklogUrl ? '?from-backlog=1' : '';
    return `${(0, $1T6m6.getBoardSettingsUrl)((0, $1T6m6.getBoardUrl)(projectKey, boardId, true))}/filter${query}`;
}

});
parcelRegister("7DE59", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad494a8e45ba6364$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7ee179aa057eaf664e0704b5803cf773>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ad494a8e45ba6364$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "BoardActions",
    "selections": [
        {
            "alias": "projectKey",
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "ScalarField",
            "name": "projectId"
        },
        {
            "kind": "ScalarField",
            "name": "projectType"
        }
    ],
    "type": "JiraProject"
};
$ad494a8e45ba6364$var$node.hash = "5bec975119349e415418460f22de0625";
var $ad494a8e45ba6364$export$2e2bcd8739ae039 = $ad494a8e45ba6364$var$node;

});

parcelRegister("9Wqfs", function(module, exports) {
$parcel$export(module.exports, "default", () => $c57a00c72036028f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $fdpHV = parcelRequire("fdpHV");

var $7iHUq = parcelRequire("7iHUq");

var $aP411 = parcelRequire("aP411");


var $55zw4 = parcelRequire("55zw4");

var $i6aaC = parcelRequire("i6aaC");

var $G61cz = parcelRequire("G61cz");

var $csIDH = parcelRequire("csIDH");
// eslint-disable-next-line jira/react/no-class-components
class $c57a00c72036028f$var$DeleteModal extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            onInitialised: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onBoardDeleted: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        };
    }
    constructor(props){
        super(props);
        this.store = (0, $G61cz.default)((0, $55zw4.default));
        this.store.dispatch((0, $i6aaC.setAppProps)(this.props));
        this.store.dispatch((0, $i6aaC.getActiveSprints)());
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7iHUq.default), {
            store: this.store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aP411.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $csIDH.default), null)));
    }
}
var $c57a00c72036028f$export$2e2bcd8739ae039 = (0, $fdpHV.AnalyticsSource)('deleteBoard', (0, $aa42ce8e355d58fa$export$1171103ea9083ffa))($c57a00c72036028f$var$DeleteModal);

});
// SCREENS
const $aa42ce8e355d58fa$export$f636b5b56f1d624a = 'Screen';
const $aa42ce8e355d58fa$export$9d2de6eebf7462b5 = 'Drawer';
const $aa42ce8e355d58fa$export$1171103ea9083ffa = 'Modal';
const $aa42ce8e355d58fa$export$cae2783c9279926 = 'InlineDialog';
const $aa42ce8e355d58fa$export$d1123261ca8831d2 = 'Dropdown';
const $aa42ce8e355d58fa$export$238d30785c4bca84 = 'Banner';
const $aa42ce8e355d58fa$export$a1562d08625f5d7e = 'UI';
const $aa42ce8e355d58fa$export$947dac6c72b26f81 = 'TRACK';
const $aa42ce8e355d58fa$export$f1d537d508d2945a = 'SCREEN';
const $aa42ce8e355d58fa$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("55zw4", function(module, exports) {
$parcel$export(module.exports, "default", () => $d935b7d2eddd5790$export$2e2bcd8739ae039);

var $4tM8k = parcelRequire("4tM8k");

var $i5MPC = parcelRequire("i5MPC");

var $5KtTM = parcelRequire("5KtTM");
var // @ts-expect-error - TS2769 - No overload matches this call.
$d935b7d2eddd5790$export$2e2bcd8739ae039 = (0, $4tM8k.combineEpics)((0, $i5MPC.default), (0, $5KtTM.default));

});
parcelRegister("i5MPC", function(module, exports) {
$parcel$export(module.exports, "default", () => $0f34796173529b03$export$2e2bcd8739ae039);
parcelRequire("9BkTq");
parcelRequire("c1D7V");
parcelRequire("6cJUr");

var $7kixv = parcelRequire("7kixv");

var $eSnSE = parcelRequire("eSnSE");

var $jbabP = parcelRequire("jbabP");

var $i6aaC = parcelRequire("i6aaC");

var $4TMFo = parcelRequire("4TMFo");
const $0f34796173529b03$var$deleteBoardEpic = (action$, store)=>action$.ofType((0, $i6aaC.DELETE_BOARD)).mergeMap(()=>{
        const state = store.getState();
        const board = (0, $4TMFo.getBoard)(state);
        return (0, $jbabP.default)(board.id).mergeMap(()=>{
            (0, $4TMFo.getOnBoardDeleted)(state)(board);
            return (0, $7kixv.Observable).of((0, $i6aaC.boardDeleted)());
        }).catch((error)=>{
            (0, $eSnSE.default).safeErrorWithoutCustomerData('directories.boards-v2.delete-modal.ops.delete-board', error.message, error);
            const reason = error.statusCode === 404 ? 'board-not-found' : 'unknown';
            (0, $4TMFo.getOnBoardDeleteFailed)(state)(board, reason);
            return (0, $7kixv.Observable).of((0, $i6aaC.deleteBoardFailed)({
                reason: reason
            }));
        });
    });
var $0f34796173529b03$export$2e2bcd8739ae039 = $0f34796173529b03$var$deleteBoardEpic;

});
parcelRegister("jbabP", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca52d1789fdf57e9$export$2e2bcd8739ae039);

var $aU4yQ = parcelRequire("aU4yQ");
const $ca52d1789fdf57e9$var$deleteBoard = (boardId)=>{
    const url = `/rest/agile/1.0/board/${boardId}`;
    const options = {
        method: 'delete'
    };
    return (0, $aU4yQ.default)(url, options);
};
var $ca52d1789fdf57e9$export$2e2bcd8739ae039 = $ca52d1789fdf57e9$var$deleteBoard;

});
parcelRegister("aU4yQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $7f2fe0ad349c30f0$export$2e2bcd8739ae039);

var $iWqim = parcelRequire("iWqim");

var $7kixv = parcelRequire("7kixv");
parcelRequire("9BkTq");
parcelRequire("c1D7V");
parcelRequire("llumX");
parcelRequire("1o2WJ");
parcelRequire("6cJUr");

var $6uWhG = parcelRequire("6uWhG");

var $eBhI6 = parcelRequire("eBhI6");

var $iMEaK = parcelRequire("iMEaK");

var $14RSn = parcelRequire("14RSn");

var $gUVFX = parcelRequire("gUVFX");

var $kinkG = parcelRequire("kinkG");
const $7f2fe0ad349c30f0$var$noContentStatus = 204;
const $7f2fe0ad349c30f0$var$transformUrl = (url)=>{
    const lUrl = url.replace(/\//g, '_');
    const resUrl = lUrl.substr(0, lUrl.indexOf('?') > -1 ? lUrl.indexOf('?') : lUrl.length);
    return resUrl;
};
// This function returns a JSON stream which emits a single JSON value on success, and throws
// an error on failure
// Pass the perf object in the options in order to enable performance analytics for your request
// fetchJson$ = ('some url', { perf: { key: 'analytics_key', prefix: 'analytics_prefix' } })
// Pass the headersProcessor in the options to provide a callback function which can respond on headers.
function $7f2fe0ad349c30f0$var$fetchJson$(url, options = {}) {
    const { perf: perf, headersProcessor: headersProcessor, ...opts } = options;
    let key;
    const isPerformanceCheckEnabled = !!perf;
    if (isPerformanceCheckEnabled) {
        const mark = `REST${$7f2fe0ad349c30f0$var$transformUrl(url)}`;
        key = perf && `${perf.prefix != null && perf.prefix !== '' ? `${perf.prefix}_` : ''}${perf.key}` || mark;
        (0, $6uWhG.setMark)(`BEGIN_${key}`);
    }
    return (0, $7kixv.Observable).of(url).mergeMap(()=>fetch((0, $gUVFX.getReroutableURL)(url), (0, $iWqim.merge)((0, $iWqim.merge)((0, $eBhI6.defaultOptions), opts), (0, $kinkG.makeObservabilityHeaders)()))).mergeMap((response)=>{
        if (isPerformanceCheckEnabled) (0, $6uWhG.setMark)(`END_${key}`);
        if (!response.ok) {
            const { status: status } = response;
            return response.text().then((str)=>{
                const traceId = response.headers.get((0, $iMEaK.TRACE_ID_HEADER));
                if (traceId != null && traceId !== '') throw new (0, $14RSn.default)(status, str, traceId);
                else throw new (0, $14RSn.default)(status, str);
            });
        }
        if (typeof headersProcessor === 'function') headersProcessor(response.headers);
        if (response.status === $7f2fe0ad349c30f0$var$noContentStatus) // We want it to return a `null` value.
        // Using `Observable.empty<never>()` would just hang as `mergeMap`
        // will be waiting for values that would never come.
        return (0, $7kixv.Observable).of(null);
        return response.json();
    });
}
var $7f2fe0ad349c30f0$export$2e2bcd8739ae039 = $7f2fe0ad349c30f0$var$fetchJson$;

});


parcelRegister("i6aaC", function(module, exports) {
$parcel$export(module.exports, "SET_APP_PROPS", () => $76e165d216c71d1e$export$8aefe701a6f431e0);
$parcel$export(module.exports, "setAppProps", () => $76e165d216c71d1e$export$cfda7627848a58cd);
$parcel$export(module.exports, "GET_ACTIVE_SPRINTS", () => $76e165d216c71d1e$export$590db52f99257537);
$parcel$export(module.exports, "getActiveSprints", () => $76e165d216c71d1e$export$2893b8608d2a6d6a);
$parcel$export(module.exports, "ACTIVE_SPRINTS_RETRIEVED", () => $76e165d216c71d1e$export$215dde409662413);
$parcel$export(module.exports, "activeSprintsRetrieved", () => $76e165d216c71d1e$export$12dcad2fd94d0a72);
$parcel$export(module.exports, "GET_ACTIVE_SPRINTS_FAILED", () => $76e165d216c71d1e$export$14cf35077b6f85f7);
$parcel$export(module.exports, "getActiveSprintsFailed", () => $76e165d216c71d1e$export$694c6ee523cd87cb);
$parcel$export(module.exports, "DELETE_BOARD", () => $76e165d216c71d1e$export$a68d619e7022f2c3);
$parcel$export(module.exports, "deleteBoard", () => $76e165d216c71d1e$export$fc0ef3a3a9b2b3cd);
$parcel$export(module.exports, "DELETE_BOARD_FAILED", () => $76e165d216c71d1e$export$8cad23f5fe7e6ff3);
$parcel$export(module.exports, "deleteBoardFailed", () => $76e165d216c71d1e$export$983279b2aa6031b0);
$parcel$export(module.exports, "BOARD_DELETED", () => $76e165d216c71d1e$export$aea8ac0fecc03cf6);
$parcel$export(module.exports, "boardDeleted", () => $76e165d216c71d1e$export$d6d2ce109de8e68b);
const $76e165d216c71d1e$export$8aefe701a6f431e0 = 'state.SET_APP_PROPS';
const $76e165d216c71d1e$export$cfda7627848a58cd = (payload)=>({
        type: $76e165d216c71d1e$export$8aefe701a6f431e0,
        payload: payload
    });
const $76e165d216c71d1e$export$590db52f99257537 = 'state.GET_ACTIVE_SPRINTS';
const $76e165d216c71d1e$export$2893b8608d2a6d6a = ()=>({
        type: $76e165d216c71d1e$export$590db52f99257537
    });
const $76e165d216c71d1e$export$215dde409662413 = 'state.ACTIVE_SPRINTS_RETRIEVED';
const $76e165d216c71d1e$export$12dcad2fd94d0a72 = (payload)=>({
        type: $76e165d216c71d1e$export$215dde409662413,
        payload: payload
    });
const $76e165d216c71d1e$export$14cf35077b6f85f7 = 'state.GET_ACTIVE_SPRINTS_FAILED';
const $76e165d216c71d1e$export$694c6ee523cd87cb = ()=>({
        type: $76e165d216c71d1e$export$14cf35077b6f85f7
    });
const $76e165d216c71d1e$export$a68d619e7022f2c3 = 'state.DELETE_BOARD';
const $76e165d216c71d1e$export$fc0ef3a3a9b2b3cd = ()=>({
        type: $76e165d216c71d1e$export$a68d619e7022f2c3
    });
const $76e165d216c71d1e$export$8cad23f5fe7e6ff3 = 'state.DELETE_BOARD_FAILED';
const $76e165d216c71d1e$export$983279b2aa6031b0 = (payload)=>({
        type: $76e165d216c71d1e$export$8cad23f5fe7e6ff3,
        payload: payload
    });
const $76e165d216c71d1e$export$aea8ac0fecc03cf6 = 'state.BOARD_DELETED';
const $76e165d216c71d1e$export$d6d2ce109de8e68b = ()=>({
        type: $76e165d216c71d1e$export$aea8ac0fecc03cf6
    });

});

parcelRegister("4TMFo", function(module, exports) {
$parcel$export(module.exports, "getBoard", () => $d78c44282fa01a48$export$2223f2dfcfd77cef);
$parcel$export(module.exports, "getOnInitialised", () => $d78c44282fa01a48$export$47263859bc15a8b8);
$parcel$export(module.exports, "getOnBoardDeleted", () => $d78c44282fa01a48$export$3efb56c7750e8ce1);
$parcel$export(module.exports, "getOnBoardDeleteFailed", () => $d78c44282fa01a48$export$311506722a7438bc);
$parcel$export(module.exports, "getOnCancel", () => $d78c44282fa01a48$export$2c6267c00ffc9906);
$parcel$export(module.exports, "isDeleteInProgress", () => $d78c44282fa01a48$export$906c0d65e4ece39d);
$parcel$export(module.exports, "getSprintInformation", () => $d78c44282fa01a48$export$4e64490e97fad74a);
const $d78c44282fa01a48$export$2223f2dfcfd77cef = (state)=>state.appProps.board;
const $d78c44282fa01a48$export$47263859bc15a8b8 = (state)=>state.appProps.onInitialised;
const $d78c44282fa01a48$export$3efb56c7750e8ce1 = (state)=>state.appProps.onBoardDeleted;
const $d78c44282fa01a48$export$311506722a7438bc = (state)=>state.appProps.onBoardDeleteFailed;
const $d78c44282fa01a48$export$2c6267c00ffc9906 = (state)=>state.appProps.onCancel;
const $d78c44282fa01a48$export$906c0d65e4ece39d = (state)=>state.isDeleteInProgress;
const $d78c44282fa01a48$export$4e64490e97fad74a = (state)=>state.sprintInformation;

});


parcelRegister("5KtTM", function(module, exports) {
$parcel$export(module.exports, "default", () => $c8af70837cc6bb8a$export$2e2bcd8739ae039);
parcelRequire("cBiei");
parcelRequire("9BkTq");
parcelRequire("c1D7V");
parcelRequire("6cJUr");

var $7kixv = parcelRequire("7kixv");


var $eSnSE = parcelRequire("eSnSE");

var $03Bz6 = parcelRequire("03Bz6");

var $i6aaC = parcelRequire("i6aaC");

var $4TMFo = parcelRequire("4TMFo");
const $c8af70837cc6bb8a$var$getActiveSprintsEpic = (action$, store)=>action$.ofType((0, $i6aaC.GET_ACTIVE_SPRINTS)).mergeMap(()=>{
        const state = store.getState();
        const board = (0, $4TMFo.getBoard)(state);
        // @ts-expect-error - TS2339 - Property 'isPrivate' does not exist on type 'Board'. | TS2339 - Property 'type' does not exist on type 'Board'.
        const shouldSkipCheckingActiveSprints = board.isPrivate || board.type !== (0, $987928229d6d4941$export$b75edebf0c64f31e);
        if (shouldSkipCheckingActiveSprints) {
            (0, $4TMFo.getOnInitialised)(state)();
            return (0, $7kixv.Observable).of((0, $i6aaC.activeSprintsRetrieved)([]));
        }
        return (0, $7kixv.Observable).fromPromise((0, $03Bz6.default)(board.id)).mergeMap((sprints)=>{
            (0, $4TMFo.getOnInitialised)(state)();
            return (0, $7kixv.Observable).of((0, $i6aaC.activeSprintsRetrieved)(sprints));
        })// @ts-expect-error - TS2345 - Argument of type '(error: FetchError) => Observable<ActiveSprintsRetrievedAction> | Observable<GetActiveSprintsFailedAction>' is not assignable to parameter of type '(err: any, caught: Observable<ActiveSprintsRetrievedAction>) => ObservableInput<ActiveSprintsRetrievedAction>'.
        .catch((error)=>{
            if (error.statusCode === 404) return (0, $7kixv.Observable).of((0, $i6aaC.activeSprintsRetrieved)([]));
            (0, $eSnSE.default).safeErrorWithoutCustomerData('directories.boards-v2.delete-modal.ops.get-active-sprints', error.message, error);
            return (0, $7kixv.Observable).of((0, $i6aaC.getActiveSprintsFailed)());
        });
    });
var $c8af70837cc6bb8a$export$2e2bcd8739ae039 = $c8af70837cc6bb8a$var$getActiveSprintsEpic;

});
const $987928229d6d4941$export$b75edebf0c64f31e = 'scrum';
const $987928229d6d4941$export$eff0efe8746a33f = 'kanban';
const $987928229d6d4941$export$aca095bc476d426f = 'simple';

parcelRegister("03Bz6", function(module, exports) {
$parcel$export(module.exports, "default", () => $d389876c4ca627fe$export$2e2bcd8739ae039);

var $jje8P = parcelRequire("jje8P");
const $d389876c4ca627fe$var$getActiveSprints1 = async (boardId)=>{
    const activeSprints = await (0, $jje8P.default)(boardId);
    return activeSprints.values;
};
var $d389876c4ca627fe$export$2e2bcd8739ae039 = $d389876c4ca627fe$var$getActiveSprints1;

});
parcelRegister("jje8P", function(module, exports) {
$parcel$export(module.exports, "default", () => $48ce5890180dbcff$export$2e2bcd8739ae039);

var $b5RwB = parcelRequire("b5RwB");

var $hgi0g = parcelRequire("hgi0g");
const $48ce5890180dbcff$var$getActiveSprints = (boardId)=>{
    const params = (0, $b5RwB.stringify)({
        state: 'active'
    });
    return (0, $hgi0g.default)(`/rest/agile/1.0/board/${boardId}/sprint?${params}`);
};
var $48ce5890180dbcff$export$2e2bcd8739ae039 = $48ce5890180dbcff$var$getActiveSprints;

});




parcelRegister("G61cz", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb4652d616bdb8da$export$2e2bcd8739ae039);

var $gs6vs = parcelRequire("gs6vs");

var $dYsG4 = parcelRequire("dYsG4");
const $bb4652d616bdb8da$var$createStore = (rootEpic)=>(0, $gs6vs.default)({
        appName: 'directories/boards-v2/delete-modal',
        rootReducer: $dYsG4.default,
        rootEpic: rootEpic
    });
var $bb4652d616bdb8da$export$2e2bcd8739ae039 = $bb4652d616bdb8da$var$createStore;

});
parcelRegister("dYsG4", function(module, exports) {
$parcel$export(module.exports, "default", () => $07a380f8d34f3189$export$2e2bcd8739ae039);

var $i6aaC = parcelRequire("i6aaC");
const $07a380f8d34f3189$var$defaultState = {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    appProps: undefined,
    sprintInformation: undefined,
    isDeleteInProgress: false
};
const $07a380f8d34f3189$var$rootReducer = (state = $07a380f8d34f3189$var$defaultState, action)=>{
    switch(action.type){
        case 0, $i6aaC.SET_APP_PROPS:
            return {
                ...state,
                appProps: action.payload
            };
        case 0, $i6aaC.DELETE_BOARD:
            return {
                ...state,
                isDeleteInProgress: true
            };
        case 0, $i6aaC.DELETE_BOARD_FAILED:
            return {
                ...state,
                isDeleteInProgress: false
            };
        case 0, $i6aaC.ACTIVE_SPRINTS_RETRIEVED:
            return {
                ...state,
                sprintInformation: {
                    sprints: action.payload
                }
            };
        case 0, $i6aaC.GET_ACTIVE_SPRINTS_FAILED:
            return {
                ...state,
                sprintInformation: {
                    error: true
                }
            };
        case 0, $i6aaC.GET_ACTIVE_SPRINTS:
        case 0, $i6aaC.BOARD_DELETED:
            return state;
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var $07a380f8d34f3189$export$2e2bcd8739ae039 = $07a380f8d34f3189$var$rootReducer;

});


parcelRegister("csIDH", function(module, exports) {
$parcel$export(module.exports, "default", () => $2de5a333ac8f356d$export$2e2bcd8739ae039);

var $eq3Hf = parcelRequire("eq3Hf");

var $idGBm = parcelRequire("idGBm");

var $gnQAk = parcelRequire("gnQAk");

var $i6aaC = parcelRequire("i6aaC");

var $4TMFo = parcelRequire("4TMFo");

var $2lKGI = parcelRequire("2lKGI");

var $dXndk = parcelRequire("dXndk");
const $2de5a333ac8f356d$var$mapStateToProps = (state)=>({
        Content: $2lKGI.default,
        board: (0, $4TMFo.getBoard)(state),
        sprintInformation: (0, $4TMFo.getSprintInformation)(state),
        deleteInProgress: (0, $4TMFo.isDeleteInProgress)(state),
        onCancel: (0, $4TMFo.getOnCancel)(state)
    });
var $2de5a333ac8f356d$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))((0, $idGBm.injectIntlV2), (0, $gnQAk.connect)($2de5a333ac8f356d$var$mapStateToProps, {
    onDelete: (0, $i6aaC.deleteBoard)
}))(// @ts-expect-error - Argument of type 'typeof DeleteBoardsModal' is not assignable to parameter of type 'ComponentType<{ intl: IntlShapeV2 | IntlShape | undefined; }>'.
(0, $dXndk.default));

});
parcelRegister("2lKGI", function(module, exports) {
$parcel$export(module.exports, "default", () => $d8e63b2d91b7c97f$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $4TMFo = parcelRequire("4TMFo");

var $5EVym = parcelRequire("5EVym");
const $d8e63b2d91b7c97f$var$mapStateToProps = (state)=>({
        board: (0, $4TMFo.getBoard)(state),
        sprintInformation: (0, $4TMFo.getSprintInformation)(state)
    });
var // @ts-expect-error - Argument of type 'ComponentType<WithIntlProps<Props>>' is not assignable to parameter of type 'ComponentType<Matching<{ board: Board; sprintInformation: SprintInformation | undefined; } & {}, WithIntlProps<Props>>>'.
$d8e63b2d91b7c97f$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($d8e63b2d91b7c97f$var$mapStateToProps, {})((0, $5EVym.default));

});
parcelRegister("5EVym", function(module, exports) {
$parcel$export(module.exports, "default", () => $47b2d28127361a21$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $eJ9f5 = parcelRequire("eJ9f5");

var $3cMgR = parcelRequire("3cMgR");

var $4cTDP = parcelRequire("4cTDP");

var $kDaaB = parcelRequire("kDaaB");

var $idGBm = parcelRequire("idGBm");

var $545Q1 = parcelRequire("545Q1");
// eslint-disable-next-line jira/react/no-class-components
class $47b2d28127361a21$var$Content extends (0, $eJOHy.Component) {
    renderContentForPrivateBoard() {
        const { intl: { formatMessage: formatMessage } } = this.props;
        return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $545Q1.default).privateBoardMessageIssueTerminologyRefreshM4 : (0, $545Q1.default).privateBoardMessage)));
    }
    renderLearnMoreLink(board) {
        const { intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
            as: "p"
        }, formatMessage((0, $545Q1.default).activeSprintsRecommendation, {
            boardName: board.name
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
            as: "p"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
            as: "em"
        }, (0, $4cTDP.fg)('replace-anchor-with-link__jira-cosmos') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
            href: "https://confluence.atlassian.com/jirasoftwarecloud/running-sprints-in-a-scrum-project-764478111.html"
        }, formatMessage((0, $545Q1.default).link)) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("a", {
            href: "https://confluence.atlassian.com/jirasoftwarecloud/running-sprints-in-a-scrum-project-764478111.html"
        }, formatMessage((0, $545Q1.default).link)))));
    }
    renderContentForNoSprints(board) {
        const { intl: { formatMessage: formatMessage } } = this.props;
        return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $545Q1.default).noSprintsMessageIssueTerminologyRefreshM4 : (0, $545Q1.default).noSprintsMessage, {
            boardName: board.name
        })));
    }
    renderContentForSingleSprint(board, sprint) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
            ...(0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $545Q1.default).singleSprintMessageIssueTerminologyRefreshM4 : (0, $545Q1.default).singleSprintMessage,
            // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
            values: {
                sprintName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("a", {
                    href: sprint.url
                }, sprint.name)
            }
        })), this.renderLearnMoreLink(board));
    }
    renderContentForMultipleSprints(board, sprints) {
        const { intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $545Q1.default).multipleSprintsMessageIssueTerminologyRefreshM4 : (0, $545Q1.default).multipleSprintsMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("ul", null, sprints.map(({ name: name, url: url }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("li", {
                key: index
            }, (0, $4cTDP.fg)('replace-anchor-with-link__jira-cosmos') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
                href: url
            }, name) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("a", {
                href: url
            }, name)))), this.renderLearnMoreLink(board));
    }
    renderContentForSprintRetrievalError(board) {
        const { intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $545Q1.default).retrievalFailedMessageIssueTerminologyRefreshM4 : (0, $545Q1.default).retrievalFailedMessage, {
            boardName: board.name
        })), this.renderLearnMoreLink(board));
    }
    render() {
        const { board: board, sprintInformation: sprintInformation } = this.props;
        // @ts-expect-error - TS2339 - Property 'isPrivate' does not exist on type 'Board'.
        if (board.isPrivate) return this.renderContentForPrivateBoard();
        // @ts-expect-error - TS2339 - Property 'error' does not exist on type 'SprintInformation'.
        if (sprintInformation.error) // @ts-expect-error - TS2345 - Argument of type 'Board' is not assignable to parameter of type 'PublicBoard'.
        return this.renderContentForSprintRetrievalError(board);
        // @ts-expect-error - TS2339 - Property 'sprints' does not exist on type 'SprintInformation'.
        if (sprintInformation.sprints.length === 1) // @ts-expect-error - TS2345 - Argument of type 'Board' is not assignable to parameter of type 'PublicBoard'. | TS2339 - Property 'sprints' does not exist on type 'SprintInformation'.
        return this.renderContentForSingleSprint(board, sprintInformation.sprints[0]);
        // @ts-expect-error - TS2339 - Property 'sprints' does not exist on type 'SprintInformation'.
        if (sprintInformation.sprints.length > 1) // @ts-expect-error - TS2345 - Argument of type 'Board' is not assignable to parameter of type 'PublicBoard'. | TS2339 - Property 'sprints' does not exist on type 'SprintInformation'.
        return this.renderContentForMultipleSprints(board, sprintInformation.sprints);
        // @ts-expect-error - TS2345 - Argument of type 'Board' is not assignable to parameter of type 'PublicBoard'.
        return this.renderContentForNoSprints(board);
    }
}
var $47b2d28127361a21$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($47b2d28127361a21$var$Content);

});
parcelRegister("545Q1", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b94325d82a5ef70$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $5b94325d82a5ef70$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    singleSprintMessage: {
        "id": "directories.boards-v2.delete-modal.content.single-sprint-message",
        "defaultMessage": "This board contains issues from {sprintName}, and that sprint is currently active."
    },
    multipleSprintsMessage: {
        "id": "directories.boards-v2.delete-modal.content.multiple-sprints-message",
        "defaultMessage": "This board contains issues from these active sprints:"
    },
    retrievalFailedMessage: {
        "id": "directories.boards-v2.delete-modal.content.retrieval-failed-message",
        "defaultMessage": "Just a heads up, we're having trouble getting information about active sprints. Issues on {boardName} might be part of one."
    },
    activeSprintsRecommendation: {
        "id": "directories.boards-v2.delete-modal.content.active-sprints-recommendation",
        "defaultMessage": "We recommend completing or deleting active sprints before deleting {boardName}."
    },
    noSprintsMessage: {
        "id": "directories.boards-v2.delete-modal.content.no-sprints-message",
        "defaultMessage": "Deleting {boardName} doesn't affect the issues on the board. And, it won't complete or delete any active sprints."
    },
    privateBoardMessage: {
        "id": "directories.boards-v2.delete-modal.content.private-board-message",
        "defaultMessage": "Deleting this board doesn't affect the issues on the board. And, it won't complete or delete any active sprints."
    },
    link: {
        "id": "directories.boards-v2.delete-modal.content.link",
        "defaultMessage": "Learn more about running sprints."
    },
    singleSprintMessageIssueTerminologyRefreshM4: {
        "id": "directories.boards-v2.delete-modal.content.single-sprint-message-issue-terminology-refresh-m4",
        "defaultMessage": "This board contains work items from {sprintName}, and that sprint is currently active."
    },
    multipleSprintsMessageIssueTerminologyRefreshM4: {
        "id": "directories.boards-v2.delete-modal.content.multiple-sprints-message-issue-terminology-refresh-m4",
        "defaultMessage": "This board contains work items from these active sprints:"
    },
    retrievalFailedMessageIssueTerminologyRefreshM4: {
        "id": "directories.boards-v2.delete-modal.content.retrieval-failed-message-issue-terminology-refresh-m4",
        "defaultMessage": "Just a heads up, we're having trouble getting information about active sprints. Work items on {boardName} might be part of one."
    },
    noSprintsMessageIssueTerminologyRefreshM4: {
        "id": "directories.boards-v2.delete-modal.content.no-sprints-message-issue-terminology-refresh-m4",
        "defaultMessage": "Deleting {boardName} doesn't affect the work items on the board. And, it won't complete or delete any active sprints."
    },
    privateBoardMessageIssueTerminologyRefreshM4: {
        "id": "directories.boards-v2.delete-modal.content.private-board-message-issue-terminology-refresh-m4",
        "defaultMessage": "Deleting this board doesn't affect the work items on the board. And, it won't complete or delete any active sprints."
    }
});

});



parcelRegister("dXndk", function(module, exports) {
$parcel$export(module.exports, "default", () => $c40e6d7fd4cf37bf$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $goZPP = parcelRequire("goZPP");

var $ik0CA = parcelRequire("ik0CA");
var $kseeK = parcelRequire("kseeK");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");

var $bu8Y7 = parcelRequire("bu8Y7");

var $guWba = parcelRequire("guWba");

var $fgJkD = parcelRequire("fgJkD");

var $4B7rn = parcelRequire("4B7rn");

var $6zXPf = parcelRequire("6zXPf");

var $cHtIB = parcelRequire("cHtIB");

var $kqd31 = parcelRequire("kqd31");

var $fKOQa = parcelRequire("fKOQa");

var $kj7UG = parcelRequire("kj7UG");
function $c40e6d7fd4cf37bf$var$DeleteBoardsModal(props) {
    const { Content: Content, board: board, sprintInformation: sprintInformation, deleteInProgress: deleteInProgress, onCancel: onCancel, onDelete: onDelete } = props;
    const { intl: { formatMessage: formatMessage } } = props;
    const tenantId = (0, $cHtIB.useCloudId)();
    const { deleteBoard: deleteBoard } = (0, $fKOQa.useDeleteBoard)();
    if (!sprintInformation) return null;
    const onCancelOrNoop = !deleteInProgress ? onCancel : (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    // @ts-expect-error - TS2339 - Property 'isPrivate' does not exist on type 'Board'.
    const heading = board.isPrivate ? formatMessage((0, $kj7UG.default).deletePrivateBoard) : // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'Board'.
    formatMessage((0, $kj7UG.default).deleteBoard, {
        boardName: board.name
    });
    const handleDelete = ()=>{
        const boardARI = (0, $bu8Y7.JiraSoftwareBoardAri).create({
            siteId: tenantId,
            boardId: board.id.toString() ?? ''
        }).toString();
        const dataId = (0, $kqd31.default)({
            id: boardARI
        }, 'JiraBoard');
        onDelete();
        if (dataId) deleteBoard(dataId);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4B7rn.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fgJkD.ModalDialog), {
        messageId: "delete-boards-modal.modal-dialog",
        messageType: "transactional",
        onClose: onCancelOrNoop
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2qG7I.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5a9Ro.default), {
        appearance: "danger"
    }, heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ik0CA.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Content, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guWba.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kseeK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "danger",
        onClick: (0, $6zXPf.getWillShowNav4)() ? handleDelete : onDelete,
        isDisabled: deleteInProgress
    }, formatMessage((0, $kj7UG.default).deleteCaption)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle-link",
        onClick: onCancelOrNoop,
        isDisabled: deleteInProgress
    }, formatMessage((0, $kj7UG.default).cancel)))));
}
$c40e6d7fd4cf37bf$var$DeleteBoardsModal.defaultProps = {
    deleteInProgress: false,
    onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    onDelete: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
};
var $c40e6d7fd4cf37bf$export$2e2bcd8739ae039 = $c40e6d7fd4cf37bf$var$DeleteBoardsModal;

});
parcelRegister("fKOQa", function(module, exports) {
$parcel$export(module.exports, "useDeleteBoard", () => $310233bfb980cc12$export$abd16ada93ebfa6a);

var $j4oe4 = parcelRequire("j4oe4");
const $310233bfb980cc12$export$16ded94db5ddbcd7 = ({ environment: environment })=>{
    const deleteBoard = (boardDataId)=>{
        (0, $j4oe4.commitLocalUpdate)(environment, (store)=>{
            store.delete(boardDataId);
        });
    };
    return {
        deleteBoard: deleteBoard
    };
};
const $310233bfb980cc12$export$abd16ada93ebfa6a = ()=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    return $310233bfb980cc12$export$16ded94db5ddbcd7({
        environment: environment
    });
};

});

parcelRegister("kj7UG", function(module, exports) {
$parcel$export(module.exports, "default", () => $575994af172f506a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $575994af172f506a$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    deleteBoard: {
        "id": "directories.boards-v2.delete-modal.delete-board",
        "defaultMessage": "Delete {boardName}"
    },
    deletePrivateBoard: {
        "id": "directories.boards-v2.delete-modal.delete-private-board",
        "defaultMessage": "Delete board"
    },
    cancel: {
        "id": "directories.boards-v2.delete-modal.cancel",
        "defaultMessage": "Cancel"
    },
    deleteCaption: {
        "id": "directories.boards-v2.delete-modal.delete-caption",
        "defaultMessage": "Delete"
    }
});

});




parcelRegister("8QGVd", function(module, exports) {
$parcel$export(module.exports, "isBoardRoute", () => $94656fa01dfef750$export$437d4d6e25681588);
$parcel$export(module.exports, "isBacklogRoute", () => $94656fa01dfef750$export$bcb853db5e3e8054);
const $94656fa01dfef750$export$437d4d6e25681588 = (routeName)=>routeName === 'rapidboard-board' || routeName === 'rapidboard-board-embed' || routeName === 'rapidboard-board-settings' || routeName === 'rapidboard-user-board' || routeName === 'rapidboard-user-board-settings' || routeName === 'servicedesk-boards' || routeName === 'servicedesk-queues-custom-board' || routeName === 'servicedesk-queues-practice-custom-board';
const $94656fa01dfef750$export$bcb853db5e3e8054 = (routeName)=>routeName === 'rapidboard-backlog' || routeName === 'rapidboard-user-backlog' || routeName === 'rapidboard-backlog-embed';

});

const $bc40578f06d7846b$export$f06dfcec5ff912e = 'meatballDropdown';
const $bc40578f06d7846b$export$7ae7abcf2c19d3e5 = 'removeFromStarred';
const $bc40578f06d7846b$export$78fd0bd637fe1684 = 'addToStarred';
const $bc40578f06d7846b$export$c540230986f848f6 = 'addPeople';
const $bc40578f06d7846b$export$44d67b522cbcce6d = 'projects';
const $bc40578f06d7846b$export$3cc9ab700c406a19 = 'projectSettings';
const $bc40578f06d7846b$export$dc23a793cf9e9de8 = 'archiveProject';
const $bc40578f06d7846b$export$a68d619e7022f2c3 = 'deleteBoard';
const $bc40578f06d7846b$export$22748439827110a4 = 'deleteProject';
const $bc40578f06d7846b$export$192d610b0b7719f4 = 'boardSettings';
const $bc40578f06d7846b$export$a65812b4aab631bb = 'alertSettings';
const $bc40578f06d7846b$export$36b5d4d0cb4e437 = 'moveInSidebar';
const $bc40578f06d7846b$export$ca6db12118be69a1 = 'schemas';
const $bc40578f06d7846b$export$f2eca6cf19c9a973 = 'reports';
const $bc40578f06d7846b$export$147264622218a553 = 'dataManager';
const $bc40578f06d7846b$export$ee52916f9ebd8000 = 'adapters';
const $bc40578f06d7846b$export$83d40997eb7cc5b7 = 'assetsGlobalConfiguration';
const $bc40578f06d7846b$export$5c09fa42f8d45ed8 = 'dismissRecommendation';
const $bc40578f06d7846b$export$de9ad1ebeca97ec1 = 'newDiscoveryProject';
const $bc40578f06d7846b$export$27e4092edca7bb97 = 'jwmSampleProject';
const $bc40578f06d7846b$export$ce0bea1467165424 = 'whyAmISeeingThis';
const $bc40578f06d7846b$export$98d08638c2a90c44 = 'starredAndRecentProjects';
const $bc40578f06d7846b$export$ed36b1ade72db400 = 'starredProjectsOnly';
const $bc40578f06d7846b$export$f8a73cc0211412ca = 'mostRecentProjectOnly';
const $bc40578f06d7846b$export$3e2efdbdb3eed97e = 'moreProjects';
const $bc40578f06d7846b$export$2de7e56f66635690 = 'viewAllProjects';
const $bc40578f06d7846b$export$e338c40e64df0640 = 'projectsSearch';
const $bc40578f06d7846b$export$5ff59e4f08b9b299 = 'moveToTop';
const $bc40578f06d7846b$export$9964b4a63620a911 = 'moveUp';
const $bc40578f06d7846b$export$2692a384035c5ef7 = 'moveDown';
const $bc40578f06d7846b$export$a5a45050b97fca24 = 'moveToBottom';

parcelRegister("8Btof", function(module, exports) {
$parcel$export(module.exports, "useProjectsAnalyticsL4", () => $696f8389ac5d4d5f$export$cc7d25cb07e1eb10);

var $eJOHy = parcelRequire("eJOHy");


var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");





var $ujg1l = parcelRequire("ujg1l");
const $696f8389ac5d4d5f$export$cc7d25cb07e1eb10 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const commonAttributes = (0, $eJOHy.useMemo)(()=>({
            level: (0, $4fdd5d9c1b32dd60$export$35ac629b8b943d5a)
        }), []);
    // actions inside meatball menu on boards
    const sendMeatBallDropDownOnBoardsMenuItemAnalyticsEvent = (0, $eJOHy.useCallback)(({ itemId: itemId, recent: recent, starred: starred, boardId: boardId, projectId: projectId, projectType: projectType })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$64fed82162bd367)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $493796f3bdee881c$export$56981f28056f258e),
            itemId: itemId,
            parentItemId: boardId,
            parentItemType: (0, $6bf6536f83c22cfe$export$9b8283d5878d2491),
            projectId: projectId,
            projectType: projectType,
            section: (0, $ujg1l.getSectionByStarredOrRecent)({
                starred: starred,
                recent: recent
            })
        };
        (0, $kRgKj.fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // actions inside meatball menu on projects
    const sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent = (0, $eJOHy.useCallback)(({ itemId: itemId, recent: recent, starred: starred, projectId: projectId, projectType: projectType })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$64fed82162bd367)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $493796f3bdee881c$export$56981f28056f258e),
            itemId: itemId,
            parentItemId: projectId,
            parentItemType: (0, $6bf6536f83c22cfe$export$fe791c4fa892e400),
            projectId: projectId,
            projectType: projectType,
            section: (0, $ujg1l.getSectionByStarredOrRecent)({
                starred: starred,
                recent: recent
            })
        };
        (0, $kRgKj.fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    return {
        sendMeatBallDropDownOnBoardsMenuItemAnalyticsEvent: sendMeatBallDropDownOnBoardsMenuItemAnalyticsEvent,
        sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent: sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent
    };
};

});
const $6bf6536f83c22cfe$export$9b8283d5878d2491 = 'board';
const $6bf6536f83c22cfe$export$c3d83ca6855fa0d0 = 'app';
const $6bf6536f83c22cfe$export$c1c49903035a02df = 'filter';
const $6bf6536f83c22cfe$export$6deee0e4f2fb784e = 'defaultFilter';
const $6bf6536f83c22cfe$export$4695c1a423ffe431 = 'dashboard';
const $6bf6536f83c22cfe$export$5828682c822c26e7 = 'queue';
const $6bf6536f83c22cfe$export$fe791c4fa892e400 = 'project';
const $6bf6536f83c22cfe$export$c303e491e026ebc6 = 'plan';
const $6bf6536f83c22cfe$export$509e83d3c8d91279 = 'appSubpage';
const $6bf6536f83c22cfe$export$a2e7d1d0a3d169f4 = 'asset';
const $6bf6536f83c22cfe$export$b56168d831461ce2 = 'operation';
const $6bf6536f83c22cfe$export$499a3e77858b7713 = 'translationGroup';
const $6bf6536f83c22cfe$export$bb8a37ab8d9ba82b = 'roadmap';
const $6bf6536f83c22cfe$export$9a778ca616c24a93 = 'projectRecommendation';
const $6bf6536f83c22cfe$export$9cbb0f231a0ab7ea = 'overview';
const $6bf6536f83c22cfe$export$119dad133da0b4a = 'changeView';

const $bfc89d778f76f56d$export$6dd9406e478a1fe2 = 'navigationItem';
const $bfc89d778f76f56d$export$b887e88d8d0739f6 = 'button';
const $bfc89d778f76f56d$export$64fed82162bd367 = 'dropdownItem';
const $bfc89d778f76f56d$export$b0a8b257f1f878a2 = 'searchInput';

const $493796f3bdee881c$export$4165a3d0da3bd147 = 'fixedItem';
const $493796f3bdee881c$export$95b0c331af13d819 = 'fixedItemButton';
const $493796f3bdee881c$export$74712b62056d422e = 'fixedItemAction';
const $493796f3bdee881c$export$3ac911b122986477 = 'customItem';
const $493796f3bdee881c$export$9bd6c21d500ae611 = 'customItemButton';
const $493796f3bdee881c$export$5374c2c2d3ece55e = 'customItemAction';
const $493796f3bdee881c$export$56981f28056f258e = 'customItemDropdownAction';
const $493796f3bdee881c$export$17bca95234dea43b = 'fixedItemDropdownAction';

const $4fdd5d9c1b32dd60$export$265c523d1a8f25cf = '1';
const $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1 = '2';
const $4fdd5d9c1b32dd60$export$f9db6a58b4aabd18 = '3';
const $4fdd5d9c1b32dd60$export$35ac629b8b943d5a = '4';


parcelRegister("aMOdH", function(module, exports) {
$parcel$export(module.exports, "ThemedButtonWrapper", () => $8b8e8a6a97695c51$export$269674ad0c604d30);
$parcel$export(module.exports, "ThemedButtonNew", () => $8b8e8a6a97695c51$export$15536ee0f9ee7c0b);
$parcel$export(module.exports, "ThemedIconButton", () => $8b8e8a6a97695c51$export$d9c2d067feb61447);
$parcel$export(module.exports, "ThemedLinkButton", () => $8b8e8a6a97695c51$export$b0b5aeed52623827);
$parcel$export(module.exports, "ThemedLinkIconButton", () => $8b8e8a6a97695c51$export$a1ab08e79d264ec8);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $5CSKW = parcelRequire("5CSKW");
var $Ay1uj = parcelRequire("Ay1uj");
var $5bY40 = parcelRequire("5bY40");
var $6K3F5 = parcelRequire("6K3F5");

var $1uv7v = parcelRequire("1uv7v");

var $4cTDP = parcelRequire("4cTDP");

var $1302Y = parcelRequire("1302Y");
const $8b8e8a6a97695c51$export$269674ad0c604d30 = ({ children: children })=>(0, $1302Y.getIsSoftwareThemingEnabled)() || (0, $4cTDP.fg)('visual-refresh-headers-buttons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "span",
        xcss: [
            $8b8e8a6a97695c51$var$overrideStyles,
            $8b8e8a6a97695c51$var$wrapperStyles,
            (0, $4cTDP.fg)('tnk-3957-quick-filters-truncate') && $8b8e8a6a97695c51$var$truncateStyles
        ]
    }, children) : children;
const $8b8e8a6a97695c51$export$15536ee0f9ee7c0b = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8b8e8a6a97695c51$export$269674ad0c604d30, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        ...props,
        ref: ref
    }))));
const $8b8e8a6a97695c51$export$d9c2d067feb61447 = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8b8e8a6a97695c51$export$269674ad0c604d30, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        ...props,
        ref: ref
    }))));
const $8b8e8a6a97695c51$export$b0b5aeed52623827 = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8b8e8a6a97695c51$export$269674ad0c604d30, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5bY40.default), {
        ...props,
        ref: ref
    }))));
const $8b8e8a6a97695c51$export$a1ab08e79d264ec8 = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8b8e8a6a97695c51$export$269674ad0c604d30, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6K3F5.default), {
        ...props,
        ref: ref
    }))));
const $8b8e8a6a97695c51$var$overrideStyles = (0, $1DXK0.xcss)({
    // @ts-expect-error Object literal may only specify known properties, and ''--ds-background-brand-bold'' does not exist in type 'SafeCSSObject'.ts(2353)
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-brand-bold': (0, $1uv7v.Tokens).COLOR_BACKGROUND_BRAND_BOLD,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-brand-bold-hovered': (0, $1uv7v.Tokens).COLOR_BACKGROUND_BRAND_BOLD_HOVERED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-brand-bold-pressed': (0, $1uv7v.Tokens).COLOR_BACKGROUND_BRAND_BOLD_PRESSED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-disabled': (0, $1uv7v.Tokens).COLOR_BACKGROUND_DISABLED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-selected': (0, $1uv7v.Tokens).COLOR_BACKGROUND_SELECTED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-selected-hovered': (0, $1uv7v.Tokens).COLOR_BACKGROUND_SELECTED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-selected-pressed': (0, $1uv7v.Tokens).COLOR_BACKGROUND_SELECTED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-neutral': (0, $1uv7v.Tokens).COLOR_BACKGROUND_NEUTRAL,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-neutral-hovered': (0, $1uv7v.Tokens).COLOR_BACKGROUND_NEUTRAL_HOVERED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-neutral-pressed': (0, $1uv7v.Tokens).COLOR_BACKGROUND_NEUTRAL_PRESSED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-neutral-subtle-hovered': (0, $1uv7v.Tokens).COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-neutral-subtle-pressed': (0, $1uv7v.Tokens).COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-icon-subtle': (0, $1uv7v.Tokens).COLOR_TEXT_SUBTLE,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-icon': (0, $1uv7v.Tokens).COLOR_TEXT,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-link': (0, $1uv7v.Tokens).COLOR_LINK,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-link-pressed': (0, $1uv7v.Tokens).COLOR_LINK_PRESSED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-text': (0, $1uv7v.Tokens).COLOR_TEXT_SUBTLE,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-text-disabled': (0, $1uv7v.Tokens).COLOR_TEXT_DISABLED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-text-inverse': (0, $1uv7v.Tokens).COLOR_TEXT_INVERSE,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-text-selected': (0, $1uv7v.Tokens).COLOR_TEXT_SELECTED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-text-subtle': (0, $1uv7v.Tokens).COLOR_TEXT_SUBTLE,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-border': (0, $1uv7v.Tokens).COLOR_BORDER,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-border-selected': (0, $1uv7v.Tokens).COLOR_BORDER_SELECTED
});
const $8b8e8a6a97695c51$var$wrapperStyles = (0, $1DXK0.xcss)({
    display: 'inline-flex'
});
const $8b8e8a6a97695c51$var$truncateStyles = (0, $1DXK0.xcss)({
    maxWidth: '100%'
});

});

parcelRegister("1T6m6", function(module, exports) {
$parcel$export(module.exports, "getBoardSettingsHref", () => $fbafacc962018516$export$8d54870ff0bbaead);
$parcel$export(module.exports, "isSelected", () => $fbafacc962018516$export$e4d153b3e021fb47);
$parcel$export(module.exports, "getBoardUrl", () => $fbafacc962018516$export$505a9f131607d070);
$parcel$export(module.exports, "getJSMBoardUrl", () => $fbafacc962018516$export$3416b472014eed93);
$parcel$export(module.exports, "getJSMCalendarUrl", () => $fbafacc962018516$export$16e1d659b389d4ae);
$parcel$export(module.exports, "getJSMListUrl", () => $fbafacc962018516$export$e221331818155e45);
$parcel$export(module.exports, "getUserBoardUrl", () => $fbafacc962018516$export$45f8e28589795b6f);
$parcel$export(module.exports, "getBoardSettingsUrl", () => $fbafacc962018516$export$222cc43a27cdf5b1);

var $cxKOj = parcelRequire("cxKOj");
function $fbafacc962018516$export$8d54870ff0bbaead(view, location) {
    if (!$fbafacc962018516$var$isServiceDeskLocation(location)) {
        const basePath = location.pathname.slice(0, location.pathname.lastIndexOf('/'));
        const query = location.search ? location.search : '';
        return `${basePath}/${view}${query}`;
    }
    if ((0, $cxKOj.expVal)('jsm_multi_project_list_view_milestone_1', 'isEnabled', false)) {
        const searchParams = new URLSearchParams(location.search);
        searchParams.set('config', view);
        return `${location.pathname}?${searchParams.toString()}`;
    }
    return `${location.pathname}?config=${view}`;
}
function $fbafacc962018516$export$e4d153b3e021fb47(view, _ = '', pathConfig = '') {
    return pathConfig === view;
}
function $fbafacc962018516$export$505a9f131607d070(projectKey, boardId, isCMPBoard) {
    return `/jira/software${isCMPBoard ? '/c' : ''}/projects/${projectKey}/boards/${boardId}`;
}
function $fbafacc962018516$export$3416b472014eed93(projectKey, boardId) {
    return `/jira/servicedesk/projects/${projectKey}/boards/${boardId}`;
}
function $fbafacc962018516$export$16e1d659b389d4ae(projectKey, boardId) {
    return `/jira/servicedesk/projects/${projectKey}/boards/${boardId}/calendar`;
}
function $fbafacc962018516$export$e221331818155e45(projectKey, boardId) {
    return `/jira/servicedesk/projects/${projectKey}/boards/${boardId}/list`;
}
function $fbafacc962018516$export$45f8e28589795b6f(accountId, boardId) {
    return `/jira/people/${accountId}/boards/${boardId}`;
}
function $fbafacc962018516$export$222cc43a27cdf5b1(ordinaryBoardUrl) {
    return `${ordinaryBoardUrl}/settings`;
}
function $fbafacc962018516$var$isServiceDeskLocation(location) {
    return location.pathname.includes('/servicedesk');
}

});

parcelRegister("9cReq", function(module, exports) {
$parcel$export(module.exports, "default", () => $128070dd19f44f46$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $128070dd19f44f46$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    boardSettingsLabel: {
        "id": "navigation-board-action-menu.board-settings-label",
        "defaultMessage": "Board settings"
    },
    deleteBoardLabel: {
        "id": "navigation-board-action-menu.delete-board-label",
        "defaultMessage": "Delete board"
    },
    dropdownIconLabel: {
        "id": "navigation-board-action-menu.dropdown-icon-label",
        "defaultMessage": "Board actions"
    }
});

});


parcelRegister("3Z5Oj", function(module, exports) {
$parcel$export(module.exports, "boardsDirectoryRoute", () => $ac00b00f7ddabdfe$export$f0fc6f4e8be87e85);
const $ac00b00f7ddabdfe$export$f0fc6f4e8be87e85 = {
    name: 'boards-directory',
    path: '/jira/boards'
};

});

parcelRegister("eNJMe", function(module, exports) {
$parcel$export(module.exports, "RedirectOnLoad", () => $3ff83db7ef64c769$export$d8efb65d35834855);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $g8Z8u = parcelRequire("g8Z8u");
const $3ff83db7ef64c769$export$d8efb65d35834855 = ({ children: children, condition: condition, href: href, redirect: redirect })=>{
    // We can save some overhead if we evaluate the condition here rather than in the hook.
    // Avoiding the hook could be helpful when wrapping this component around a number of menu items but only needing redirect on one.
    if (!condition) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)($3ff83db7ef64c769$var$RedirectOnLoadWithoutCondition, {
        href: href,
        redirect: redirect,
        children: children
    });
};
const $3ff83db7ef64c769$var$RedirectOnLoadWithoutCondition = ({ children: children, href: href, redirect: redirect })=>{
    (0, $g8Z8u.useRedirectOnLoad)(href, redirect);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });
};

});
parcelRegister("g8Z8u", function(module, exports) {
$parcel$export(module.exports, "useRedirectOnLoad", () => $0e2cfb76bf01a5ef$export$2a7b037d0b6588a0);

var $eJOHy = parcelRequire("eJOHy");

var $3QIey = parcelRequire("3QIey");
const $0e2cfb76bf01a5ef$export$2a7b037d0b6588a0 = (href, redirect, condition = true)=>{
    const willRedirectOnLoad = (0, $3QIey.useWillRedirectOnLoad)();
    const setWillRedirectOnLoad = (0, $3QIey.useSetWillRedirectOnLoad)();
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (condition && willRedirectOnLoad) {
            setWillRedirectOnLoad(false);
            redirect(href);
        }
    }, [
        condition,
        href,
        redirect,
        setWillRedirectOnLoad,
        willRedirectOnLoad
    ]);
};

});


const $62baa2e6fd157602$export$b8b9d90f9e5bd72b = '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-content-projects-jsw-project-menu';
const $62baa2e6fd157602$export$d57b6b390e78d90f = 'jira-cosmos';
const $62baa2e6fd157602$export$420a3ee5deb615a9 = 25;
const $62baa2e6fd157602$export$99240e55cc48c47e = 5;

parcelRegister("6y2u3", function(module, exports) {
$parcel$export(module.exports, "default", () => $ccfada4171aa855b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $ccfada4171aa855b$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    viewAllBoardsNonFinal: {
        "id": "navigation-apps-sidebar-nav4-jsw-project-menu.jsw-expandable-project.async-content.view-all-boards-non-final",
        "defaultMessage": "View all boards"
    }
});

});




//# sourceMappingURL=nav4-jsw-project-entry-point.8bf345d8.js.map
